<div class="main-container">
  <app-header></app-header>
  <div class="iti-page">
    <div class="iti-page-left">
      <app-nav-menu></app-nav-menu>
    </div>
    <div class="iti-page-right">
      <div class="iti-page-right-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
